<!-- <div class="card border-0 shadow-sm px-5" (click)="goToNews(newsitemView.news.id)" >
    <a href="javascript:void(0)"><img style="height: 300px;"  #newsImageId [src]="ImageData" class="card-img-top" alt="news-photo-01"></a>
    <div class="card-body">
      <p class="card-text"><small class="text-muted bg-light px-2 py-1">{{newsitemView.news.publishStateDate.toString() |date :'HH:mm yyyy LLL dd'}}</small></p>
      <a href="javascript:void(0)"><h5 class="card-title mb-6" style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display:block;">{{newsitemView.news.newsTitle}}</h5></a>
      <p class="card-text"  style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display:block;"> {{newsitemView.news.newsBody}}</p>
    </div>
  </div> -->
<div class="card border-0 shadow-sm mt-3"
     style="width:30rem; cursor:pointer;"
     (click)="goToNews(newsitemView.mediaCenter.id)">

  <!-- Show Image -->
  <img *ngIf="isImage"
       class="card-img-top"
       [src]="ImageData"
       alt="Card image cap">

  <!-- Show Video -->
  <video *ngIf="!isImage"
         class="card-img-top"
         [src]="ImageData"
         controls>
  </video>

  <div class="card-body">
    <p class="card-text">
      <small class="text-muted bg-light px-2 py-1">
        {{ newsitemView.mediaCenter.publishStateDate | luxonFormat:'HH:mm yyyy LLL dd' }}
      </small>
    </p>

    <!-- no need for clickable <a> -->
    <h5 class="card-title mb-6"
        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display:block;">
      {{ newsitemView.mediaCenter.title }}
    </h5>
  </div>
</div>